module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', [_vm._v("Donation Successful")]), _vm._v(" "), _c('sk-panel', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', {
    staticClass: "booking-successful"
  }, [_c('sk-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "check-ticket"
  }, [_c('h3', [_vm._v("Thank you! your donation is greatly appreciated!")]), _vm._v(" "), _vm._l((_vm.booking.Concessions), function(concession) {
    return _c('div', [_c('p', [_vm._v("Your contribution of "), _c('strong', {
      staticClass: "secondary--text"
    }, [_vm._v("R" + _vm._s(_vm.donationAmount))]), _vm._v("\n                                        has successfully gone through. Check your inbox for the receipt of payment.\n                                    ")])])
  })], 2)])], 1)], 1), _vm._v(" "), _c('sk-signin', {
    staticClass: "no-print"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.related_movies.length > 0) ? _c('sk-related-movies', {
    attrs: {
      "limit": "6",
      "movies": _vm.related_movies,
      "label": "Recommended Movies"
    }
  }) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), [_c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "primary": "",
      "router": "",
      "to": "/"
    }
  }, [_vm._v("\n                        Take me home\n                    ")])]], 2)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8560084","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/donate/donation-successful/donation-successful.vue
// module id = 802
// module chunks = 0